import {
  FETCH_PAYMENT_METHODS,
  FETCH_PAYMENT_METHODS_SUCCESS,
  FETCH_PAYMENT_METHODS_FAILED,
  UPDATE_WALLET_BALANCE,
  UPDATE_WALLET_BALANCE_SUCCESS,
  UPDATE_WALLET_BALANCE_FAILED,
  CLEAR_PAYMENT_MESSAGES
} from "../store/types";
import { getSupabase } from "../config/configureSupabase";

export const fetchPaymentMethods = () => async (dispatch) => {
  dispatch({
    type: FETCH_PAYMENT_METHODS,
    payload: null,
  });

  dispatch({
    type: FETCH_PAYMENT_METHODS_SUCCESS,
    payload: [{ name: 'faturamento', description: 'Faturamento / Frota' }],
  });
};

export const clearMessage = () => (dispatch) => {
  dispatch({
    type: CLEAR_PAYMENT_MESSAGES,
    payload: null,
  });
};

export const addToWallet = (uid, amount) => async (dispatch) => {
  dispatch({
    type: UPDATE_WALLET_BALANCE,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase && uid) {
    try {
      const { data: profile } = await supabase.from('profiles').select('wallet_balance').eq('id', uid).maybeSingle();
      const newBal = (Number(profile?.wallet_balance || 0) + Number(amount)).toFixed(2);
      await supabase.from('profiles').update({ wallet_balance: newBal }).eq('id', uid);
      dispatch({
        type: UPDATE_WALLET_BALANCE_SUCCESS,
        payload: null
      });
      return;
    } catch (error) {
      dispatch({
        type: UPDATE_WALLET_BALANCE_FAILED,
        payload: error.message,
      });
      return;
    }
  }

  dispatch({
    type: UPDATE_WALLET_BALANCE_SUCCESS,
    payload: null
  });
};

export const withdrawBalance = (profile, amount) => async (dispatch) => {
  dispatch({
    type: UPDATE_WALLET_BALANCE,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase && profile?.uid) {
    try {
      await supabase.from('withdraws').insert([{
        user_id: profile.uid,
        name: (profile.firstName || '') + ' ' + (profile.lastName || ''),
        amount: parseFloat(amount),
        status: 'pending'
      }]);
    } catch (e) {}
  }
};
